import { useState, useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
const categories = [{
  image: "https://nicklandscapes.co.uk/wp-content/uploads/2026/09/20231110_155350-scaled.jpg?v=c5l43nldndm",
  alt: "Stone Paving",
  title: "Brickwork",
  cta: "LEARN MORE",
  accent: "#c8b89a",
  size: "large"
}, {
  image: "https://nicklandscapes.co.uk/wp-content/uploads/2026/09/20250512_140452-scaled.jpg?v=enywfworlbq",
  alt: "Decking",
  title: "Tiling",
  cta: "LEARN MORE",
  accent: "#8a7660",
  size: "small"
}, {
  image: "https://nicklandscapes.co.uk/wp-content/uploads/2026/09/20240607_173613-scaled.jpg?v=04ml11uvzpil",
  alt: "Clay Pavers",
  title: "Lighting",
  cta: "LEARN MORE",
  accent: "#b5724a",
  size: "small"
}, {
  image: "https://nicklandscapes.co.uk/wp-content/uploads/2026/04/garden-room-london.webp?v=zjlvm9iusnd",
  alt: "Free Samples",
  title: "Garden Rooms",
  cta: "LEARN MORE",
  accent: "#d4c4a8",
  size: "large"
}];
export default function CategoryQuickLinksCopy() {
  const [signupVisible, setSignupVisible] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="relative bg-background text-foreground overflow-hidden py-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/driveway_background.png)]">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Space+Mono:wght@400;700&display=swap');`}</style>

      <div className={`transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 min-h-[520px]">
          {categories.map((cat, i) => <article key={cat.title} data-index={i} className="relative overflow-hidden cursor-pointer group" style={{
          minHeight: "420px"
        }} onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)}>
              <img src={cat.image} alt={cat.alt} className="w-full h-auto absolute inset-0 object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />

              <div className="absolute inset-0 transition-opacity duration-500" style={{
            background: hoveredIndex === i ? `linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.08) 100%)` : `linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.18) 60%, rgba(0,0,0,0.02) 100%)`
          }} />

              <div className="absolute top-0 left-0 w-full h-1 transition-all duration-300" style={{
            background: hoveredIndex === i ? cat.accent : "transparent"
          }} />

              <div className="absolute bottom-0 left-0 right-0 p-6 flex flex-col gap-4">
                

                <h2 className="text-white text-3xl lg:text-4xl font-black leading-none tracking-tight" style={{
              fontFamily: "'Playfair Display', serif"
            }}>
                  {cat.title}
                </h2>

                <div className={`transition-all duration-500 overflow-hidden ${hoveredIndex === i ? "max-h-20 opacity-100 translate-y-0" : "max-h-0 opacity-0 translate-y-4"}`}>
                  
                </div>
              </div>

              <div className="absolute inset-0 border-0 transition-all duration-300 pointer-events-none" style={{
            boxShadow: hoveredIndex === i ? `inset 0 0 0 2px ${cat.accent}` : "inset 0 0 0 0px transparent"
          }} />
            </article>)}
        </div>

        
      </div>
    </section>;
}